import {createContext} from 'react';

export const AlertContext = createContext("")

export const UserInfoContext = createContext({})

export const UserActiveCodeContext = createContext({})

export const ConfirmationContext = createContext("")
